import * as React from 'react';
import { DialogFooter, DialogHeader } from '../../../components/Dialog/@radix-styled';
import Button from 'components/Button';
import Heading from 'components/text/Heading';
import Paragraph from 'components/text/Paragraph';
import { CheckCircle2, Loader2 } from 'lucide-react';
import { useTranslation } from 'next-i18next';
import Dialog from 'components/Dialog';
import { useCreditCardApplicationUrl } from 'hooks/useCreditCardApplicationUrl';

interface Props {
  open: boolean;
  onClose: () => void;
  isLoading: boolean;
  swissLoyaltyId?: string;
}

const LoadingDialog: React.FC<Props> = props => {
  const { open, onClose, isLoading, swissLoyaltyId } = props;
  const { t } = useTranslation();
  const url = useCreditCardApplicationUrl();

  const redirectToCreditCardAppPage = () => {
    window.open(url, '_blank', 'noopener,noreferrer');
    onClose();
  };

  return (
    <Dialog onOpenChange={onClose} open={open}>
      <DialogHeader>
        {isLoading ? (
          <Loader2 className="text-primary animate-spin" size={40} />
        ) : (
          <CheckCircle2 className="text-primary" size={40} />
        )}
        <Heading variant="h4">
          {t(isLoading ? 'loyalty.modal.loading.title' : 'loyalty.modal.ready.title')}
        </Heading>
        <Paragraph color="subtle">
          {t(isLoading ? 'loyalty.modal.loading.description' : 'loyalty.modal.ready.description')}
        </Paragraph>
      </DialogHeader>
      {swissLoyaltyId != null && !isLoading ? (
        <DialogFooter>
          <Button variant="primary" onClick={redirectToCreditCardAppPage}>
            {t('loyalty.modal.cta')}
          </Button>
        </DialogFooter>
      ) : null}
    </Dialog>
  );
};

export default LoadingDialog;
